import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

import { IProposalInteractionsProps } from '../Proposal'
import { ProposalMiceCta } from '../proposal-cta/ProposalMiceCta'
import UserCurrentAction from '../proposal-cta/user-current-action/UserCurrentAction'
import {
  ClientProposalFragment,
  ClientRequestOutputDto,
  CompanyRoleEnum,
  UserOutputDto,
} from '../../../../lib/graphql'
import { getPriceFromToggleStatus } from '../../../../utils'
import { usePriceContext } from '../../../contexts'
import NonCompliantMessage from '../../../molecules/non-compliant-rules/NonCompliantMessage'

interface ProposalPriceAndCtaProps extends IProposalInteractionsProps {
  clientRequest: ClientRequestOutputDto
  clientProposal: ClientProposalFragment
  displayCta: boolean

  handleDepositPayment?: () => void
  handleBalancePayment?: () => void
  handleBalancePostFinalPayment?: () => void
  userDetails?: Pick<UserOutputDto, 'phoneNumber' | 'miceRole'>
}

export function ProposalPriceAndCta({
  adminActions,
  userActions,
  clientRequest,
  clientProposal,
  displayCta,
  handleDepositPayment,
  handleBalancePayment,
  handleBalancePostFinalPayment,
  userDetails,
}: ProposalPriceAndCtaProps) {
  const toggleStatus = usePriceContext()

  const price = clientProposal.price?.totalUser ?? undefined
  const totalPrice = getPriceFromToggleStatus({
    priceOption: price,
    toggleStatus,
  })
  const totalPriceWithDiscount = getPriceFromToggleStatus({
    priceOption: price,
    toggleStatus,
    discountPrices: true,
  })
  const hasDiscount = totalPrice !== totalPriceWithDiscount
  const isNonCompliant =
    clientProposal.isNonCompliantBudget || clientProposal.isNonCompliantHouse

  return (
    <div
      className={clsx(
        s.proposalPriceAndCta,
        { [s.alignSelfStretch]: displayCta },
        { [s.proposalPriceAndCtaWithDiscount]: hasDiscount },
      )}
    >
      {isNonCompliant && (
        <NonCompliantMessage clientProposal={clientProposal} />
      )}
      {!clientRequest.permissions.canEdit &&
      !clientRequest.selectedProposalId ? (
        <>
          {userDetails?.miceRole === CompanyRoleEnum.ADMIN ? (
            <ProposalMiceCta clientProposal={clientProposal} />
          ) : undefined}
        </>
      ) : (
        <>
          <div className={s.horizontalSeparator} />
          <UserCurrentAction
            clientRequest={clientRequest}
            clientProposal={{
              ...clientProposal,
              serviceProvider: clientProposal.serviceProvider,
            }}
            userActions={userActions}
            userDetails={userDetails}
            adminActions={adminActions}
            handleDepositPayment={handleDepositPayment}
            handleBalancePayment={handleBalancePayment}
            handlePostBalancePayment={handleBalancePostFinalPayment}
          />
        </>
      )}
    </div>
  )
}
